import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import EmptyResults from '../EmptyResults';
import VerticalPercentageStackedBarChart from '../VerticalPercentageStackedBarChart';
import HorizontalPercentageStackedBarChart from '../HorizontalPercentageStackedBarChart';
import MatrixResults from './MatrixResults';
import { ChartType } from '../../enum';
import Tooltip from './Tooltip';

function MatrixQuestionResults(props) {
  const { question, hasResponses } = props;
  const { showDataTable, data } = question;
  const { datasets, labels } = data;
  const chartRef = useRef(null);
  const isEmpty = datasets.length === 0;

  function renderChart() {
    const chartLabels = datasets.map((dataset) => dataset.label);
    const chartDatasets = labels.map((label, index) => ({
      label,
      data: datasets.map((dataset) => dataset.percentages[index]),
      counts: datasets.map((dataset) => dataset.counts[index]),
    }));

    switch (question.chartType) {
      case ChartType.VERTICAL_BAR:
        return (
          <VerticalPercentageStackedBarChart
            labels={chartLabels}
            datasets={chartDatasets}
            Tooltip={Tooltip}
          />
        );
      case ChartType.HORIZONTAL_BAR:
        return (
          <HorizontalPercentageStackedBarChart
            labels={chartLabels}
            datasets={chartDatasets}
            Tooltip={Tooltip}
          />
        );
      default:
        return null;
    }
  }

  if (isEmpty) return <EmptyResults hasResponses={hasResponses} />;

  return (
    <div className="engage-results-engagement-screen__chart-content">
      <div className="engage-results-engagement-screen__chart-content__chart" ref={chartRef}>
        {renderChart()}
      </div>
      {showDataTable && <MatrixResults data={data} />}
    </div>
  );
}

MatrixQuestionResults.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    chartType: PropTypes.string.isRequired,
    showDataTable: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      labels: PropTypes.arrayOf(PropTypes.string).isRequired,
      datasets: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          percentages: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
          counts: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
};

export default MatrixQuestionResults;
